module.exports = __webpack_public_path__ + "img/tran_4kl.d5b506b8.jpg";